import { motion } from "framer-motion";
import { Card, CardContent } from "./ui/card";
import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Swathi David",
    role: "Parent",
    content: "Tumble Gym strikes the perfect balance between play and education. My child looks forward to every session, and I’m thrilled to see the positive impact on their development.",
    rating: 5,
    image: "/ts1.webp" 
  },
  {
    name: "Krish Shetty",
    role: "Parent",
    content: "Tumble Gym is a five-star experience for families. The positive energy, skilled instructors, and emphasis on child development make it a standout choice in our community.",
    rating: 5,
    image: "/ts2.webp" 
  },
  {
    name: "Sandeep Rhonda",
    role: "Parent",
    content: "Choosing Tumble Gym was the best decision for our little one. The well-planned activities and focus on learning through play make it an exceptional place for kids to thrive.",
    rating: 5,
    image: "/ts3.webp" 
  }
];

export const Testimonials = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-purple-50">
      <div className="container mx-auto px-4">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-3xl md:text-4xl font-bold text-center text-primary mb-16"
        >
          Hear from Our Happy Families
        </motion.h2>
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
            >
              <Card className="h-full hover:shadow-xl transition-shadow">
                <CardContent className="p-6">
                  <div className="flex items-center gap-4 mb-4">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-12 h-12 rounded-full object-cover"
                      loading="lazy"
                    />
                    <div>
                      <p className="font-semibold text-gray-800">{testimonial.name}</p>
                      <p className="text-gray-500 text-sm">{testimonial.role}</p>
                    </div>
                  </div>
                  <div className="flex mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star
                        key={i}
                        className="w-5 h-5 text-yellow-400 fill-current"
                      />
                    ))}
                  </div>
                  <p className="text-gray-600">{testimonial.content}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
